import { Stack } from "@chakra-ui/react";
import { useState } from "react";
import { SellerData } from "../../models/Sellers";
import { useParams } from "react-router-dom";
import { LoginSection } from "./_LoginSection";
import { ContactSection } from "./_ContactSection";
import { AddressSection } from "./_AddressSection";
import { GeneralInfoSection } from "./_GeneralInfoSection";

interface SellerFormProps {
    seller: SellerData;
}

export const SellerForm = ({ seller }: SellerFormProps) => {
    let { id } = useParams();
    const [editSection, setEditSection] = useState("");
    return(
        seller && (
        <Stack w="100%" gap={2}>
            <GeneralInfoSection 
                editSection={editSection}
                setEdit={setEditSection}
                id={id}
                seller={
                    {
                        icon: seller.icon ?? "",
                        cnpj: seller.cnpj ?? "",
                        document: seller.cnpj ?? "",
                        fantasyName: seller.fantasyName ?? "",
                        companyName: seller.companyName ?? "",
                        ownerName: seller.ownerName ?? "",
                        ownerDocument: seller.ownerDocument ?? "",
                        birthdate: seller.birthdate ?? "",
                        openingDate: seller.openingDate ?? "",
                        categoryId: seller?.categoryId,
                        allowedForInternationalDocument: seller?.allowedForInternationalDocument,
                        sellerUrl: seller?.sellerUrl,
                        tier: seller?.tier,
                        mainActivity: seller?.mainActivity ?? ""
                    }
                }
            />
            <AddressSection 
                editSection={editSection}
                setEdit={setEditSection}
                id={id}
                address={seller.address}
            />
            <ContactSection
                editSection={editSection}
                setEdit={setEditSection}
                id={id}
                contact={seller.contact}
            />
            <LoginSection
                id={id}
            />
        </Stack>
    ))
}